import { render, staticRenderFns } from "./Passcode.vue?vue&type=template&id=64d1f29a"
import script from "./Passcode.vue?vue&type=script&lang=js"
export * from "./Passcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports